import { EventData } from '@carvana/merch-search-bar/hooks/useSearchBarEvents';
import { Consumer } from '~/constants/common/consumer';
import { useConsumer } from '~/context/common/StaticContext';

function removeNonUTF8(str: string) {
  return str.replace(/[^\x00-\x7F]/g, '');
}

export const getHrefWithSource =
  (refSource: Consumer) =>
  (href: string, eventData?: EventData): string => {
    if (!href.includes('/cars')) return href;
    const url = new URL(href, 'https://www.example.com');

    // refSource value is added to SRP mega-srp-user-info analytics event
    url.searchParams.set('refSource', refSource);

    // searchEvent object decoded by SRP
    // added to mega-srp-keyword-suggestion analytics event
    if (eventData)
      url.searchParams.set(
        'searchEvent',
        window.btoa(removeNonUTF8(JSON.stringify(eventData)))
      );

    return url.pathname + url.search;
  };

export default function useGetConsumerHref() {
  const consumer = useConsumer();

  return getHrefWithSource(consumer);
}
